<template>
    <div class="content">
        <div class="content-wrap">
            <div class="top">
                <mq-layout mq="mobile">
                    <MobileMenubar></MobileMenubar>
                </mq-layout>
                <mq-layout mq="laptop+">
                    <LaptopMenubar></LaptopMenubar>
                </mq-layout>
            </div>

            <div class="container-login" align="center">
                <div class="main-text" align="center">
                    <p class="big-text" align="center">{{l10.All_Parents_Signup_Title1}}</p>
                    <p class="sub-text" align="center">{{l10.All_Parents_Signup_Title1_Description1}}</p>
                </div>
                
                <form @submit.prevent="onSubmit(email, password, passcheck)">
                    <div class="form1">
                        <input class="user" type="email" align="center" v-model="email" :placeholder="l10.All_Parents_Signup_Title1_InputBox1">
                    </div>

                    <div class="clearfix"></div>

                    <div class="form1">
                        <input class="pass"
                            type="password" align="center" v-model="password" :placeholder="l10.All_Parents_Signup_Title1_InputBox2">
                    </div>

                    <div class="clearfix"></div>

                    <div class="form1">
                        <input class="pass-check"
                            type="password" align="center" v-model="passcheck" :placeholder="l10.All_Parents_Signup_Title1_InputBox3">
                    </div>

                    <div v-if="msg" class="wrong-text">{{msg}}</div>

                    <div class="next">
                        <input class="subm" type="submit" align="center"
                            :value="[[ l10.All_Parents_Signup_Title1_Button1 ]]"
                        />
                    </div>
                </form>
                
            </div>

        </div>

        <div class="container">
            <mq-layout mq="mobile">
                <MobileFooter></MobileFooter>
            </mq-layout>
            <mq-layout mq="laptop+">
                <LaptopFooter></LaptopFooter>
            </mq-layout>
        </div>

    </div>
</template>
<script>
import LaptopMenubar from '@/components/menubar/LaptopLayout.vue'
import MobileMenubar from '@/components/menubar/MobileLayout.vue'
import LaptopFooter from "@/components/footer/FooterLaptop.vue";
import MobileFooter from "@/components/footer/FooterMobile.vue";
import axios from 'axios'

export default {
    name: "Signup",
    components: { LaptopMenubar, MobileMenubar, LaptopFooter, MobileFooter },

    async created() {
        const sessionId = this.$store.getters.sessionId//isSignedIn;
        if (this.$store.getters.sessionId && this.$store.getters.accountId) {
            this.$store
                .dispatch("verifySession", { sessionId })
                .then(() => {
                    this.redirect();
                });
        }
    },
    data() {
        const text = require("../../text/parent/laptop.js").default;
        const l10n = text[this.$store.state.lang]
            ? text[this.$store.state.lang]
            : text["en"];
        return {
            l10: l10n,
            email: "",
            password: "",
            passcheck: "",
            msg: "",
            env: this.$store.state.env,
        };
    },
    methods: {
        redirect() {
            this.$store.dispatch("redirect");
        },
        async onSubmit(email, password, passcheck) {
            if (!email || !password || !passcheck) {
                this.msg = "";
                return;
            }

            if (password !== passcheck) {
                this.msg = this.l10.All_Parents_Signup_Title1_ErrorMessage2;
                return;
            }

            if (password.length < 6) {
                this.msg = this.l10.All_Parents_Signup_Title1_ErrorMessage4;
                return;
            }

            var engRegExp = /[A-Za-z]/
            var numRegExp = /[0-9]/
            if (!engRegExp.test(password) || !numRegExp.test(password)) {
                this.msg = this.l10.All_Parents_Signup_Title1_ErrorMessage4;
                return
            }

            for (var i=0; i<password.length; i++) {
                var code = password.charCodeAt(i)
                if (code < 32 || code > 255) {
                    this.msg = this.l10.All_Parents_Signup_Title1_ErrorMessage4;
                    return
                }
            }

            const checkRes = await axios.post(
                this.env.protocol + this.env.urlAPI + "/account/checkEmail",
                { email: email },
                { headers: { "content-type": "application/json; charset=UTF-8" } }
            );

            if (!checkRes.data.result) {
                this.$store.commit('delEmailSignup');
                this.setErrorMsg(checkRes.data.errorCode);
                return;
            }

            this.$store.commit('setEmailSignup', { email, password });
            // signup
            const { search } = window.location;
            this.$router.push("/signupAgreement" + search)
        },

        setErrorMsg(errCode) {
            if ( "All_Parents_Error_" + errCode in this.l10) {
                this.msg = this.l10["All_Parents_Error_" + errCode];
            } else {
                this.msg = "Unknown error occurred.";
            }
        },
    }
};
</script>

<style src="@/assets/account/main.css"></style>
<style scoped>
.top {
    height: 100px;
    background-color: #42c0ff;
}
.container {
    margin: 0 auto;
    height: auto;
    min-height: 100px;
    max-width: 1024px;
    background-color: #ffffff;
}
.content-wrap {
    background-color: #fffcf7;
    padding-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/pages/account/SignupEmail.vue